import React from 'react';
import {withRouter, Link} from 'react-router-dom';

const TrayContainerWithHeader = (props) => {

   const resetTrayState = event => {
      if( props.mapStore && props.mapStore.highlightedFeature && !props.mapStore.highlightId && !props.mapStore.currentItem ) {
         props.mapStore.highlightedFeature = null;
      }

      if( props.mapStore && props.mapStore.highlightedFeature && props.mapStore.highlightId ) {
         props.mapStore.highlightId = null;
      }

     if( props.mapStore && props.mapStore.highlightId ) {
       props.mapStore.highlightId = null;
     }

     if (props.mapStore && props.mapStore.foundLocationId) {
       props.mapStore.foundLocationId = null;
     }

      if( props.mapStore && props.mapStore.currentItem ) {
         props.mapStore.clearItem();
      }

      if( props.mapStore && props.mapStore.trailId ) {
         props.mapStore.trailId = null;
         props.mapStore.trailStops = [];
         props.mapStore.currentItem = null;
      }

      if( props.mapStore && props.mapStore.userLocationId ) {
         props.mapStore.userLocationId = null;
      }
   };

   const trayCloseButtonLocation = (props) => {
      let path = "/";

      if( props.mapStore && props.mapStore.highlightedFeature && !props.mapStore.highlightId && !props.mapStore.currentItem ) {
         path = "/find";
      }

      if( props.mapStore && props.mapStore.highlightedFeature && props.mapStore.highlightId ) {
         path = `/find/${props.params.id}`;
      }


      if( props.mapStore && (props.mapStore.currentItem || props.mapStore.highlightId) ) {
         path = `${props.params.path}`;
      }

      return path;
   }

   return <div className={`tray-state tray-state--${props.trayClass} is-active`}>
     {    trayCloseButtonLocation(props) !== '/' &&
         <Link to={trayCloseButtonLocation(props)} className="back" data-target="master" data-function="clear" onClick={resetTrayState}></Link>
     }
         <Link to="/" className="close" onClick={resetTrayState}></Link>
         <h2 className="tray-title">{props.title}</h2>

         {props.children}
   </div>
}

export default TrayContainerWithHeader;
